<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 16/2/2022
  -->

<template>
	<div class="qw-row qwoach-form" v-bind="attrsStylesClass">
		<div class="col px-0">

			<div class="qw-row">

				<qw-input
					:readonly="readonly"
					:class="{'white-smoke': !readonly}"
					class="col-sm mr-2"
					placeholder="Street"
					:input-debounce-delay="inputDebounceDelay"
					v-model="addressItem.street"
					:borderDotted="borderDotted"
					@change="onAddressChanged"/>
				<qw-input
					:readonly="readonly"
					:class="{'white-smoke': !readonly}"
					class="col-sm mr-2 mt-2 mt-sm-0"
					placeholder="City"
					:input-debounce-delay="inputDebounceDelay"
					v-model="addressItem.city"
					:borderDotted="borderDotted"
					@change="onAddressChanged"/>

			</div>
			<div class="qw-row">
				<qw-input
					:readonly="readonly"
					:class="{'white-smoke': !readonly}"
					class="col-sm mr-2 mt-2"
					placeholder="State/Province"
					:input-debounce-delay="inputDebounceDelay"
					v-model="addressItem.state"
					:borderDotted="borderDotted"
					@change="onAddressChanged"/>
				<qw-input
					:readonly="readonly"
					:class="{'white-smoke': !readonly}"
					class="col-sm mr-2 mt-2"
					placeholder="Country"
					:input-debounce-delay="inputDebounceDelay"
					v-model="addressItem.country"
					:borderDotted="borderDotted"
					@change="onAddressChanged"/>
				<qw-input
					:readonly="readonly"
					:class="{'white-smoke': !readonly}"
					class="col-sm mr-2 mt-2"
					placeholder="Zip Code"
					:input-debounce-delay="inputDebounceDelay"
					v-model="addressItem.zip"
					:borderDotted="borderDotted"
					@change="onAddressChanged"/>
			</div>

		</div>
	</div>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";
import AddressItem from "@shared/Profile/AddressItem";

export default {
	name: "AddressView",
	components: {},
	extends: BaseVModelView,
	inheritAttrs: false,

	props: {
		modelValue: {AddressItem, required: true},
		readonly: Boolean,
		borderDotted: Boolean,
		inputDebounceDelay: Number
	},


	methods: {
		formatDataIn(modelValue) {
			return modelValue || new AddressItem()
		},

		onAddressChanged(){
			this.notifyValueChanged()
		}
	},

	computed: {
		addressItem() {
			return this.valueData
		}
	},
}
</script>

<style lang="scss">

</style>
